import { UtilsProvider } from './../../providers/utils/utils';
import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController,
  Platform,
  ModalController
} from 'ionic-angular';
import { CameraOptions, Camera } from '@ionic-native/camera';
import { TasksProvider } from '../../providers/tasks/tasks';
import { ImageObject, TaskData, TaskQL } from '../../providers/tasks/models';
import { ENV } from '../../environments/environment';
@IonicPage()
@Component({
  selector: 'page-task-photos',
  templateUrl: 'task-photos.html'
})
export class TaskPhotosPage {
  private task: any;
  private taskData: TaskData;
  private customer: any;
  public noPhotoNeeded: boolean = false;

  private images: Array<any> = new Array(5);
  private photos: ImageObject[] = new Array(5);
  private comments: Array<any> = new Array(5);
  private ready: boolean = false;
  private labels: any[];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private camera: Camera,
    private tasksProvider: TasksProvider,
    private platform: Platform,
    private modalCtrl: ModalController,
    private utilsProvider: UtilsProvider
  ) {}

  ngOnInit() {
    this.task = this.tasksProvider.getSelectedTask();
    this.photosNeededCheck();
  }

  photosNeededCheck(){
    if(this.task.type !== 'installation'
    && this.task.deviceType === 'secdev')
    this.noPhotoNeeded = true;
  }
  ionViewDidLoad() {
    this.readyCheck();
  }
  ionViewDidEnter() {
    this.taskData = this.tasksProvider.getTaskData(this.task.id);

    // PHOTO ARRAY;

    const photosObjects = this.task.requiredImages;

    this.photos = new Array();
    for (let i = 0; i < photosObjects.length; i++) {
      const itm = { ...photosObjects[i] };
      this.photos.push(itm);
    }

    if (this.taskData.photos) {
      // merge labels passed
      for (let i = 0; i < this.taskData.photos.length; i++) {
        const img = this.taskData.photos[i];
        if (img.data) {
          this.photos[i] = img;
        }
      }
    }

    this.comments = this.taskData.comments
      ? this.taskData.comments
      : new Array(5);
    this.readyCheck();
  }

  setTempImages(taskType: string){
    let images = [
      {
        comment: "",
        label: "Image of nameplate, barcode or replacement sticker",
        src: "",
        tag: "geyserImageLabel",
      },
      {
        comment: "",
        label: "Image of geyser element wiring",
        src: "",
        tag: "geyserImageWiring",
      },
      {
        comment: "",
        label: "Image of drip tray sensor in position",
        src: "",
        tag: "geyserImageDripTray",
      }
    ]

    // Use install pics when doing replace
    if(taskType === 'installation' || taskType === 'repair'){
      this.task.requiredImages = [...images];
    }
  }

  takePhoto() {}
  addPhoto() {
    this.photos.push({
      label: '',
      data: null,
      comment: ''
    });
  }

  readyCheck() {
    if(this.noPhotoNeeded) {
      this.ready = true;
      return
    }
    let flag = true;

    let requiredPics = 3;
    if(this.task.deviceType === 'geyser' || this.task.deviceType === 'congey'){
      requiredPics = 5;
    }

    for (let i = 0; i < requiredPics; i++) {
      if (!this.photos[i] || !this.photos[i].data) {
        flag = false;
      }
    }
    this.ready = flag;
  }

  removeImage(index) {
    this.photos[index].data = null;
    this.photos[index].comment = '';
    this.tasksProvider
      .updateTaskData(this.task, 'photos', this.photos)
      .subscribe(data => {
        console.log('removed and updated');
      });
    this.readyCheck();
  }

  addComments(index: number) {
    let msg =
      this.photos[index] && this.photos[index].comment
        ? this.photos[index].comment
        : '';
    let commentModal = this.modalCtrl.create(CommentModal, {
      index: index,
      msg: msg
    });

    commentModal.onDidDismiss(data => {
      if (data) {
        this.photos[data.index].comment = data.msg;
      }
    });

    commentModal.present();
  }

  addImageInput(event, index) {
    const reader = new FileReader();

    if (event.target.files && event.target.files.length) {
      const [file] = event.target.files;
      this.utilsProvider.resizeImg(file).then(file => {
      reader.readAsDataURL(file);
      reader.onload = () => {
        this.photos[index].data = reader.result.toString().split(',')[1];
        this.readyCheck();
      };
    }).catch(e => {
        console.log("Upload Error",e)
    })
    }
  }

  photoClicked(index) {
    if (this.platform.is('cordova')) return;
    if (ENV.base.includes("qa.sens") || ENV.base.includes("local")) {
      this.utilsProvider.toDataURL('assets/img/sample.jpg').then(dataUrl => {
        let imageData = dataUrl
          .toString()
          .replace('data:image/jpeg;base64,', '');
        this.photos[index].data = imageData;
        this.readyCheck();
      });
    }
  }

  addImage(index, source = 1) {
    const options: CameraOptions = {
      quality: 75,
      destinationType: this.camera.DestinationType.DATA_URL,
      //Choose the format of the return value. Defined in Camera.DestinationType. Default is FILE_URI. DATA_URL : 0, Return image as base64-encoded string, FILE_URI : 1, Return image file URI, NATIVE_URI : 2 Return image native URI (e.g., assets-library:// on iOS or content:// on Android)
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      targetWidth: 1200,
      targetHeight: 900,
      correctOrientation: true,
      sourceType: source //Camera=1, PhotoLibrary=0, SavedPhotoAlbum=2
    };
    this.photoLight();
    this.photos[index] = {};
    if (!this.platform.is('cordova') && ENV.base.includes("qa")) {
      this.utilsProvider.toDataURL('assets/img/sample.jpg').then(dataUrl => {
        let imageData = dataUrl
          .toString()
          .replace('data:image/jpeg;base64,', '');

        this.photos[index].data = imageData;
        this.readyCheck();
      });
    } else {
      this.camera.getPicture(options).then(
        imageData => {
          // imageData is either a base64 encoded string or a file URI
          // If it's base64:
          this.photos[index].data = imageData;
          this.readyCheck();
        },
        err => {
          console.log('CAMERA ERROR: ', err);
          // Handle error
          if (!this.platform.is('cordova') && ENV.base.includes("dev")) {
            //if testing on dekstop
            this.utilsProvider
              .toDataURL('assets/img/sample.jpg')
              .then(dataUrl => {
                let imageData = dataUrl
                  .toString()
                  .replace('data:image/jpeg;base64,', '');

                this.photos[index].data = imageData;
                this.readyCheck();
              });
          } else {
            this.photos = this.cleanArray(this.photos);
          }
        }
      );
    }
  }

  openGallery(index, source = 1) {
    const options: CameraOptions = {
      quality: 100,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      sourceType: this.camera.PictureSourceType.SAVEDPHOTOALBUM
    };
    if (!this.platform.is('cordova') && ENV.base.includes("qa")) {
      this.utilsProvider.toDataURL('assets/img/sample.jpg').then(dataUrl => {
        let imageData = dataUrl
          .toString()
          .replace('data:image/jpeg;base64,', '');

        this.photos[index].data = imageData;
        this.readyCheck();
      });
    } else {
      this.camera.getPicture(options).then(
        imageData => {
          // imageData is either a base64 encoded string or a file URI
          // If it's base64:
          this.photos[index].data = imageData;
          this.readyCheck();
        },
        err => {
          // Handle error
        }
      );
    }
  }

  isCordova() {
    return this.platform.is('cordova');
  }

  chunk(arr, size) {
    var newArr = [];
    for (var i = 0; i < arr.length; i += size) {
      newArr.push(arr.slice(i, i + size));
    }
    return newArr;
  }
  cleanArray(actual) {
    var newArray = new Array();
    for (var i = 0; i < actual.length; i++) {
      if ((actual[i] && actual[i].data) || i < 5) {
        newArray.push(actual[i]);
      }
    }
    return newArray;
  }
  updateTask() {
    if(this.photos.length === 0 && this.noPhotoNeeded) this.navCtrl.pop();
    this.tasksProvider
      .updateTaskData(this.task, 'photos', this.photos)
      .subscribe(data => {
        this.navCtrl.pop();
      });
  }

  getIndex(rc, cc) {
    return rc * cc;
  }

  async photoLight(){
    const torch = await createTorch();
    await torch.on();
  }

}

// comment module
@Component({
  selector: 'comment-modal',
  template: `
    <ion-header>
      <ion-navbar>
        <ion-buttons start>
          <button ion-button (click)="dismiss()">Close</button>
        </ion-buttons>
        <ion-title>Comments</ion-title>
      </ion-navbar>
    </ion-header>
    <ion-content padding>
      <ion-list>
        <ion-item>
          <ion-textarea
            placeholder="Add a comment"
            [(ngModel)]="msg"
            required
          ></ion-textarea>
        </ion-item>
      </ion-list>
      <div padding>
        <button color="light" ion-button full primary (click)="cancel()">
          Cancel
        </button>
        <button
          color="primary"
          [disabled]="msg.length == 0"
          ion-button
          full
          primary
          (click)="addComment()"
        >
          Add Comment
        </button>
      </div>
    </ion-content>
  `
})
export class CommentModal {
  private index: number;
  private msg: string;
  constructor(public viewCtrl: ViewController, params: NavParams) {
    this.index = params.get('index');
    this.msg = params.get('msg') ? params.get('msg') : '';
  }

  addComment() {
    this.viewCtrl.dismiss({
      index: this.index,
      msg: this.msg
    });
  }

  cancel() {
    this.dismiss();
  }

  dismiss() {
    let data = { msg: this.msg, index: this.index };
    this.viewCtrl.dismiss(data);
  }
}

export class Torch {
  private mediaStreamTrack?: MediaStreamTrack;
  private enabled = false;
  public async setup() {
    if (!("mediaDevices" in navigator)) {
      throw new Error("Environment does not support mediaDevices");
    }
    if (!("ImageCapture" in window)) {
      throw new Error("Environment does not support ImageCapture");
    }
    const stream = await navigator.mediaDevices.getUserMedia({
      audio: false,
      video: {
        facingMode: "environment"
      }
    });
    const tracks = stream.getVideoTracks();
    if (tracks.length === 0) {
      throw new Error("Could not find rear camera");
    }
    this.mediaStreamTrack = tracks[0];
  }
  public async toggle(enableFlash = !this.enabled) {
    // tslint:disable no-object-literal-type-assertion
    if (!this.mediaStreamTrack) {
      return;
    }
    const constraint = { torch: enableFlash } as MediaTrackConstraintSet;
    // Silently fail if we have to, but log to console.
    // tslint:disable no-console
    try {
      await this.mediaStreamTrack.applyConstraints({
        advanced: [constraint]
      });
      this.enabled = enableFlash;
    } catch (err) {
      console.error("Ignoring error:", err);
    }
  }
  public on() {
    return this.toggle(true);
  }
  public off() {
    return this.toggle(false);
  }
  public stop() {
    if (!this.mediaStreamTrack) {
      return;
    }
    this.mediaStreamTrack.stop();
    this.mediaStreamTrack = undefined;
  }
}
export async function createTorch(): Promise<Torch> {
  const torch = new Torch();
  await torch.setup();
  return torch;
}



// WEBPACK FOOTER //
// ./src/pages/task-photos/task-photos.ts